import React, { createContext, useState, useContext } from 'react';

const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [user, setUser] = useState(
    JSON.parse(localStorage.getItem('user')) || null
  );
  const [cart, setCart] = useState([]);

  const login = (userData, token) => {
    setUser(userData);
    localStorage.setItem('user', JSON.stringify(userData));
    localStorage.setItem('token', token);
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('user');
    localStorage.removeItem('token');
  };

  const addToCart = (product, size = 'M') => {
    const existing = cart.find(
      (item) => item._id === product._id && item.size === size
    );
    if (existing) {
      setCart(cart.map((item) =>
        item._id === product._id && item.size === size
          ? { ...item, quantity: item.quantity + 1 }
          : item
      ));
    } else {
      setCart([...cart, { ...product, quantity: 1, size }]);
    }
  };

  const removeFromCart = (productId, size) => {
    setCart(cart.filter(
      (item) => !(item._id === productId && item.size === size)
    ));
  };

  const clearCart = () => setCart([]);

  const cartTotal = cart.reduce(
    (total, item) => total + item.price * item.quantity, 0
  );

  const cartCount = cart.reduce(
    (count, item) => count + item.quantity, 0
  );

  return (
    <AppContext.Provider value={{
      user, login, logout,
      cart, addToCart, removeFromCart, clearCart,
      cartTotal, cartCount,
    }}>
      {children}
    </AppContext.Provider>
  );
};

export const useApp = () => useContext(AppContext);